import React from 'react';

import {
  useDeleteFinancialResult,
  useCommentFinancialResult,
  useUndoFinancialResult,
  useMoreInfoFinancialResult,
  useApproveFinancialResult,
  useRejectFinancialResult,
} from 'scenes/FinancialResults/data/mutations';

import { Actions } from './Actions';
import { ActionsOnDraft } from '../Draft/ActionsOnDraft';
import { STATUS_DRAFT } from '../../constants';

export const FrActions = ({
  data,
  onEdit,
  onDelete,
  onDuplicate,
  actions,
  withViewLog = false,
}) => {
  const [deleteFinancialResult] = useDeleteFinancialResult();
  const [commentFinancialResult] = useCommentFinancialResult();
  const [undoFinancialResult] = useUndoFinancialResult();
  const [moreInfoFinancialResult] = useMoreInfoFinancialResult();

  const [approveFinancialResult] = useApproveFinancialResult();
  const [rejectFinancialResult] = useRejectFinancialResult();

  const handleUndo = async () => {
    await undoFinancialResult(data);
  };

  const handleRequestMoreInfo = async () => {
    await moreInfoFinancialResult(data);
  };

  const handleApproveFinancialResult = async () => {
    await approveFinancialResult(data);
  };

  const handleRejectFinancialResult = async () => {
    await rejectFinancialResult(data);
  };

  const handleDelete = async () => {
    await deleteFinancialResult(data);
    if (typeof onDelete === 'function') {
      onDelete();
    }
  };
  const handleAddComment = async () => {
    await commentFinancialResult(data);
  };
  const handleEdit = async () => await onEdit(data);
  const handleDuplicate = async () => await onDuplicate(data);

  return (
    <Actions
      actions={actions}
      onEdit={handleEdit}
      onDuplicate={handleDuplicate}
      onDelete={handleDelete}
      onAddComment={handleAddComment}
      onUndo={handleUndo}
      onRequestMoreInfo={handleRequestMoreInfo}
      onApprove={handleApproveFinancialResult}
      onReject={handleRejectFinancialResult}
      withViewLog={withViewLog}
    />
  );
};

export default (params) => {
  if (params?.data?.status?.id === STATUS_DRAFT) {
    return <ActionsOnDraft {...params} />;
  }
  return <FrActions {...params} />;
};
